import React from "react";
import type { DriverDeliveriesSummary as DriverDeliveriesSummaryType } from "../../types/driverDeliveries";
import { formatMoney } from "../../utils/driverDeliveries";

type DriverDeliveriesSummaryProps = {
  summary: DriverDeliveriesSummaryType;
  commissionLabel: string;
  pickupTotal?: number;
};

const gridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: "16px",
};

const cardStyle = (accent: string): React.CSSProperties => ({
  border: "1px solid var(--border)",
  borderTop: `3px solid ${accent}`,
  borderRadius: "22px",
  background:
    "linear-gradient(180deg, var(--surface) 0%, var(--surface) 68%, var(--surface-alt) 100%)",
  boxShadow: "var(--shadow)",
  padding: "14px 16px",
  minHeight: "132px",
});

const labelStyle: React.CSSProperties = {
  fontSize: "12px",
  fontWeight: 700,
  color: "var(--text-secondary)",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  marginBottom: "10px",
};

const valueStyle: React.CSSProperties = {
  fontSize: "22px",
  fontWeight: 900,
  color: "var(--text-primary)",
  lineHeight: 1.1,
};

const helperStyle: React.CSSProperties = {
  fontSize: "13px",
  color: "var(--text-secondary)",
  marginTop: "10px",
  lineHeight: 1.5,
};

const negativeStyle: React.CSSProperties = {
  color: "var(--danger)",
  fontWeight: 700,
};

const DriverDeliveriesSummary = ({
  summary,
  pickupTotal = 0,
}: DriverDeliveriesSummaryProps) => {
  const totalFinal = summary.netoTotal + pickupTotal;

  return (
    <div style={gridStyle}>
      <div style={cardStyle("var(--primary)")}>
        <div style={labelStyle}>Envíos</div>
        <div style={valueStyle}>{summary.totalEnvios}</div>
        <div style={helperStyle}>total de envíos</div>
      </div>

    <div style={cardStyle("var(--success)")}>
  <div style={labelStyle}>Neto</div>
  <div style={valueStyle}>$ {formatMoney(summary.netoTotal)}</div>
  <div style={helperStyle}>neto a liquidar</div>
</div>

      <div style={cardStyle("var(--primary)")}>
        <div style={labelStyle}>Colecta</div>
        <div style={valueStyle}>$ {formatMoney(pickupTotal)}</div>
        <div style={helperStyle}>
          espacio reservado para liquidación de colecta
        </div>
      </div>

      <div style={cardStyle("var(--primary)")}>
        <div style={labelStyle}>Total</div>
        <div style={valueStyle}>$ {formatMoney(totalFinal)}</div>
        <div style={helperStyle}>neto + colecta</div>
      </div>
    </div>
  );
};

export default DriverDeliveriesSummary;